// customer-lookup.function.ts

export interface CustomerLookupInput {
  firstName?: string | null;
  middleName?: string | null;
  lastName?: string | null;
  phone?: string | null;
}

export interface CustomerLookupResult {
  fullName: string | null;
  phone: string | null;
}

export function extractNumericPhone(phone?: string | null): string | null {
  const numeric = (phone ?? '').replace(/\D/g, '');
  return numeric || null;
}

export function buildFullNameForLookup(first?: string | null, middle?: string | null, last?: string | null): string | null {
  const f = (first ?? '').trim();
  const m = (middle ?? '').trim();
  const l = (last ?? '').trim();

  if (!f || !l) {
    return null;
  }

  return m ? `${f} ${m} ${l}` : `${f} ${l}`;
}

export function getCustomerLookupData(input: CustomerLookupInput): CustomerLookupResult {
  return {
    fullName: buildFullNameForLookup(input.firstName, input.middleName, input.lastName),
    phone: extractNumericPhone(input.phone),
  };
}

export function canCheckExistingCustomer(input: CustomerLookupInput): boolean {
  const r = getCustomerLookupData(input);
  return !!r.fullName && !!r.phone;
}
